import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_truck-booking-black.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_boat.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_o_plane-booking-black.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center py-2 pr-4 pl-6" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_4 = { class: "text-black-lp-100 text-2xl font-bold" }
const _hoisted_5 = {
  class: "flex flex-row items-center gap-2 font-medium text-black-lp-100 pl-2 border-l",
  style: {"border-color":"#E5E7EB"}
}
const _hoisted_6 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_7 = { class: "bg-gray-lp-1200 py-2 px-4 h-full overflow-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: `/cargo-v2/${_ctx.no}/info?id=${_ctx.id}`
        }, {
          default: _withCtx(() => [
            _createVNode("img", {
              src: _imports_0,
              class: "w-6 cursor-pointer",
              alt: _ctx.$t('cargoV2.components.common.backAlt')
            }, null, 8, ["alt"])
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("cargoV2.components.editLayout.title")), 1),
          _createVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.originCityCode) + " ", 1),
            (_ctx.cargoType === 'truck')
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _imports_1,
                  class: "w-4 h-4",
                  alt: _ctx.$t('cargoV2.components.common.transportAlt')
                }, null, 8, ["alt"]))
              : _createCommentVNode("", true),
            (_ctx.cargoType === 'ship')
              ? (_openBlock(), _createBlock("img", {
                  key: 1,
                  src: _imports_2,
                  class: "w-4 h-4",
                  alt: _ctx.$t('cargoV2.components.common.transportAlt')
                }, null, 8, ["alt"]))
              : _createCommentVNode("", true),
            (_ctx.cargoType === 'plane')
              ? (_openBlock(), _createBlock("img", {
                  key: 2,
                  src: _imports_3,
                  class: "w-4 h-4",
                  alt: _ctx.$t('cargoV2.components.common.transportAlt')
                }, null, 8, ["alt"]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.destinationCityCode), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_lp_button, {
          title: _ctx.$t('cargoV2.components.common.save'),
          textColor: "white",
          color: "red-lp-2400",
          disabled: _ctx.isDisabledEditBtn,
          onClick: _cache[1] || (_cache[1] = () => _ctx.$emit('save'))
        }, null, 8, ["title", "disabled"])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}